import UserChangePassword from './UserChangePasswordContainer'

export default UserChangePassword
